(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-reminder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mountSelector = '[data-cart-reminder-mount]';
    const reminderSelector = '[data-cart-reminder]';
    const pageLaunchDelay = 4000;
    let pageLoaded = false;
    let pageLaunchAt = 0;
    const storagePrefix = 'childecor:cartReminder:v2:';
    const localKeys = {
      eligibleSessions: 'eligibleSessions',
      closeCount: 'closeCount',
      pauseUntil: 'pauseUntil',
    };
    const sessionKeys = {
      registered: 'registered',
      sessionIndex: 'sessionIndex',
      dueAt: 'dueAt',
      dismissed: 'dismissed',
      shown: 'shown',
    };

    function storageGet(area, key) {
      try {
        return window[area].getItem(`${storagePrefix}${key}`);
      } catch (error) {
        return null;
      }
    }

    function storageSet(area, key, value) {
      try {
        window[area].setItem(`${storagePrefix}${key}`, String(value));
      } catch (error) {
        // Storage can be unavailable in private browsing. The reminder still fails safely.
      }
    }

    function storageRemove(area, key) {
      try {
        window[area].removeItem(`${storagePrefix}${key}`);
      } catch (error) {
        // No action is needed when browser storage is unavailable.
      }
    }

    function readNumber(area, key) {
      const value = Number.parseInt(storageGet(area, key) || '0', 10);
      return Number.isFinite(value) ? value : 0;
    }

    function dataNumber(mount, key, fallback) {
      const value = Number.parseInt(mount.dataset[key] || '', 10);
      return Number.isFinite(value) ? value : fallback;
    }

    function cartCount(mount) {
      return dataNumber(mount, 'cartCount', 0);
    }

    function pathContainsCartOrCheckout() {
      return /(^|\/)(cart|checkout|checkouts)(\/|$)/.test(window.location.pathname.toLowerCase());
    }

    function isCartOrCheckoutPage(mount) {
      const pageType = (mount.dataset.pageType || '').toLowerCase();
      return pageType === 'cart' || pageType === 'checkout' || pathContainsCartOrCheckout();
    }

    function isProductPage(mount) {
      return (mount.dataset.pageType || '').toLowerCase() === 'product';
    }

    function isExcludedPage(mount) {
      return isProductPage(mount) || isCartOrCheckoutPage(mount);
    }

    function isDesignMode(mount) {
      return mount.dataset.designMode === 'true';
    }

    function isPaused(mount) {
      const pauseUntil = readNumber('localStorage', localKeys.pauseUntil);
      if (!pauseUntil) return false;
      if (pauseUntil > Date.now()) return true;

      storageRemove('localStorage', localKeys.pauseUntil);
      storageSet('localStorage', localKeys.closeCount, 0);
      return false;
    }

    function getRemainingFullHours() {
      try {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/New_York',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: false,
        }).formatToParts(new Date());
        let hour = Number.parseInt(parts.find((part) => part.type === 'hour')?.value || '0', 10);
        const minute = Number.parseInt(parts.find((part) => part.type === 'minute')?.value || '0', 10);
        const second = Number.parseInt(parts.find((part) => part.type === 'second')?.value || '0', 10);
        if (hour >= 24) hour = 0;
        const remaining = 86400 - (hour * 3600 + minute * 60 + second);
        return Math.floor((remaining > 0 ? remaining : 86400) / 3600);
      } catch (error) {
        const now = new Date();
        const hour = (now.getUTCHours() - 5 + 24) % 24;
        const remaining = 86400 - (hour * 3600 + now.getUTCMinutes() * 60 + now.getUTCSeconds());
        return Math.floor((remaining > 0 ? remaining : 86400) / 3600);
      }
    }

    function updateSaleHours(reminder) {
      const value = reminder.querySelector('[data-cart-reminder-sale-hours]');
      const unit = reminder.querySelector('[data-cart-reminder-hour-unit]');
      if (!value || !unit) return;
      const hours = getRemainingFullHours();
      value.textContent = hours;
      unit.textContent = hours === 1 ? unit.dataset.hour : unit.dataset.hours;
    }

    function hideReminder(mount) {
      const reminder = mount.querySelector(reminderSelector);
      if (!reminder) return;
      reminder.classList.remove('is-visible');
      window.clearInterval(mount._cartReminderSaleTimer);
      window.setTimeout(() => {
        if (!reminder.classList.contains('is-visible')) reminder.hidden = true;
      }, 310);
    }

    function clearScheduledWork(mount) {
      window.clearTimeout(mount._cartReminderTimer);
      mount._cartReminderTimer = undefined;
      mount._cartReminderDrawerObserver?.disconnect();
      mount._cartReminderDrawerObserver = undefined;
    }

    function suppressForSession(mount) {
      clearScheduledWork(mount);
      if (!isDesignMode(mount)) {
        storageSet('sessionStorage', sessionKeys.dismissed, 1);
        storageRemove('sessionStorage', sessionKeys.dueAt);
      }
      hideReminder(mount);
    }

    function snoozeReminder(mount, countClose = false) {
      clearScheduledWork(mount);
      hideReminder(mount);
      const repeatDelay = dataNumber(mount, 'repeatDelay', 60);

      if (isDesignMode(mount)) {
        mount._cartReminderTimer = window.setTimeout(() => showReminder(mount, true), repeatDelay * 1000);
        return;
      }

      if (countClose) recordReminderClose(mount);
      storageRemove('sessionStorage', sessionKeys.shown);
      storageSet('sessionStorage', sessionKeys.dueAt, Date.now() + repeatDelay * 1000);
      if (!isPaused(mount) && !isExcludedPage(mount)) scheduleReminder(mount);
    }

    function resetCartCycle(mount) {
      clearScheduledWork(mount);
      hideReminder(mount);
      Object.values(localKeys).forEach((key) => storageRemove('localStorage', key));
      Object.values(sessionKeys).forEach((key) => storageRemove('sessionStorage', key));
    }

    function registerEligibleSession(mount, resetDelay, showImmediatelyForExistingCart = false) {
      let sessionIndex = readNumber('sessionStorage', sessionKeys.sessionIndex);
      const isNewSession = storageGet('sessionStorage', sessionKeys.registered) !== '1';

      if (isNewSession) {
        sessionIndex = readNumber('localStorage', localKeys.eligibleSessions) + 1;
        storageSet('localStorage', localKeys.eligibleSessions, sessionIndex);
        storageSet('sessionStorage', sessionKeys.registered, 1);
        storageSet('sessionStorage', sessionKeys.sessionIndex, sessionIndex);
      }

      if (isNewSession && showImmediatelyForExistingCart) {
        storageSet('sessionStorage', sessionKeys.dueAt, Date.now());
      } else if (resetDelay || !readNumber('sessionStorage', sessionKeys.dueAt)) {
        const firstDelay = dataNumber(mount, 'firstDelay', 40);
        const returningDelay = dataNumber(mount, 'returningDelay', 120);
        const delay = sessionIndex <= 1 ? firstDelay : returningDelay;
        storageSet('sessionStorage', sessionKeys.dueAt, Date.now() + delay * 1000);
      }

      return sessionIndex;
    }

    function recordReminderClose(mount) {
      const limit = dataNumber(mount, 'closesBeforePause', 3);
      const pauseHours = dataNumber(mount, 'pauseHours', 2);
      const nextCount = readNumber('localStorage', localKeys.closeCount) + 1;

      if (nextCount >= limit) {
        storageSet('localStorage', localKeys.closeCount, 0);
        storageSet('localStorage', localKeys.pauseUntil, Date.now() + pauseHours * 60 * 60 * 1000);
      } else {
        storageSet('localStorage', localKeys.closeCount, nextCount);
      }
    }

    function isCartSurfaceOpen() {
      return Boolean(
        document.querySelector('cart-drawer.active') ||
          document.querySelector('cart-notification .cart-notification.active')
      );
    }

    function waitForCartSurfaceToClose(mount) {
      mount._cartReminderDrawerObserver?.disconnect();
      const surfaces = document.querySelectorAll('cart-drawer, cart-notification .cart-notification');
      if (!surfaces.length) return;

      const observer = new MutationObserver(() => {
        if (isCartSurfaceOpen()) return;
        observer.disconnect();
        mount._cartReminderDrawerObserver = undefined;
        scheduleReminder(mount);
      });

      surfaces.forEach((surface) => observer.observe(surface, { attributes: true, attributeFilter: ['class'] }));
      mount._cartReminderDrawerObserver = observer;
    }

    async function refreshMount(mount) {
      if (mount._cartReminderRefresh) return mount._cartReminderRefresh;

      mount._cartReminderRefresh = (async () => {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('sections', mount.dataset.sectionId);
          const response = await fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });
          if (!response.ok) return cartCount(mount);

          const sections = await response.json();
          const html = sections[mount.dataset.sectionId];
          if (!html) return cartCount(mount);

          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const nextMount = parsed.querySelector(mountSelector);
          if (!nextMount) return cartCount(mount);

          const dataKeys = [
            'pageType',
            'cartCount',
            'firstDelay',
            'returningDelay',
            'repeatDelay',
            'closesBeforePause',
            'pauseHours',
            'designMode',
          ];
          dataKeys.forEach((key) => {
            if (nextMount.dataset[key] !== undefined) mount.dataset[key] = nextMount.dataset[key];
          });
          mount.innerHTML = nextMount.innerHTML;
          return cartCount(mount);
        } catch (error) {
          return cartCount(mount);
        }
      })();

      try {
        return await mount._cartReminderRefresh;
      } finally {
        mount._cartReminderRefresh = undefined;
      }
    }

    function bindReminderControls(mount, reminder) {
      if (reminder.dataset.initialized === 'true') return;
      reminder.dataset.initialized = 'true';

      const closeButton = reminder.querySelector('[data-cart-reminder-close]');
      closeButton?.addEventListener('click', () => snoozeReminder(mount, true));

      const cartLink = reminder.querySelector('[data-cart-reminder-cart-link]');
      cartLink?.addEventListener('click', () => suppressForSession(mount));
    }

    function canShow(mount) {
      return (
        cartCount(mount) > 0 &&
        !isExcludedPage(mount) &&
        !isPaused(mount) &&
        storageGet('sessionStorage', sessionKeys.dismissed) !== '1' &&
        storageGet('sessionStorage', sessionKeys.shown) !== '1'
      );
    }

    async function showReminder(mount, preview = false) {
      if (mount._cartReminderOpening) return;
      if (!preview && !canShow(mount)) return;
      if (preview && (cartCount(mount) <= 0 || isExcludedPage(mount))) return;
      mount._cartReminderOpening = true;

      try {
        let reminder = mount.querySelector(reminderSelector);
        if (!reminder) {
          await refreshMount(mount);
          reminder = mount.querySelector(reminderSelector);
        }
        if (!reminder) return;
        if (!preview && !canShow(mount)) return;

        if (isCartSurfaceOpen()) {
          waitForCartSurfaceToClose(mount);
          return;
        }

        if (!preview) {
          storageSet('sessionStorage', sessionKeys.shown, 1);
          storageRemove('sessionStorage', sessionKeys.dueAt);
        }

        bindReminderControls(mount, reminder);
        updateSaleHours(reminder);
        window.clearInterval(mount._cartReminderSaleTimer);
        mount._cartReminderSaleTimer = window.setInterval(() => updateSaleHours(reminder), 60000);

        reminder.hidden = false;
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => reminder.classList.add('is-visible'));
        });
      } finally {
        mount._cartReminderOpening = false;
      }
    }

    function scheduleReminder(mount) {
      window.clearTimeout(mount._cartReminderTimer);
      if (!canShow(mount)) return;
      if (!pageLoaded) return;

      const dueAt = readNumber('sessionStorage', sessionKeys.dueAt);
      if (!dueAt) return;
      const wait = Math.max(0, dueAt - Date.now(), pageLaunchAt - Date.now());
      mount._cartReminderTimer = window.setTimeout(() => showReminder(mount), wait);
    }

    function scheduleDesignPreview(mount) {
      window.clearTimeout(mount._cartReminderTimer);
      if (!pageLoaded) return;
      const wait = Math.max(0, pageLaunchAt - Date.now());
      mount._cartReminderTimer = window.setTimeout(() => showReminder(mount, true), wait);
    }

    function markPageLoaded() {
      if (pageLoaded) return;
      pageLoaded = true;
      pageLaunchAt = Date.now() + pageLaunchDelay;

      document.querySelectorAll(mountSelector).forEach((mount) => {
        if (mount.dataset.initialized !== 'true') return;
        if (isDesignMode(mount)) {
          scheduleDesignPreview(mount);
        } else {
          scheduleReminder(mount);
        }
      });
    }

    async function handleCartUpdate(mount, event) {
      const source = event?.source || '';
      const isAdd = source !== 'cart-items';
      const reportedCount = Number.parseInt(event?.cartData?.item_count, 10);

      if (reportedCount === 0) {
        mount.dataset.cartCount = '0';
        resetCartCycle(mount);
        return;
      }

      const updatedCount = await refreshMount(mount);
      if (updatedCount <= 0) {
        resetCartCycle(mount);
        return;
      }

      if (isCartOrCheckoutPage(mount)) {
        clearScheduledWork(mount);
        hideReminder(mount);
        return;
      }

      if (isPaused(mount)) return;
      if (storageGet('sessionStorage', sessionKeys.dismissed) === '1') return;
      if (storageGet('sessionStorage', sessionKeys.shown) === '1') return;

      registerEligibleSession(mount, isAdd);
      if (!isExcludedPage(mount)) scheduleReminder(mount);
    }

    function initMount(mount) {
      if (!mount || mount.dataset.initialized === 'true') return;
      mount.dataset.initialized = 'true';

      if (isDesignMode(mount)) {
        if (cartCount(mount) > 0 && !isExcludedPage(mount)) scheduleDesignPreview(mount);
        return;
      }

      const onKeydown = (event) => {
        const reminder = mount.querySelector(reminderSelector);
        if (event.key === 'Escape' && reminder?.classList.contains('is-visible')) snoozeReminder(mount);
      };

      document.addEventListener('keydown', onKeydown);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        mount._cartReminderUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          void handleCartUpdate(mount, event);
        });
      }

      mount._cartReminderCleanup = () => {
        clearScheduledWork(mount);
        window.clearInterval(mount._cartReminderSaleTimer);
        mount._cartReminderUnsubscribe?.();
        document.removeEventListener('keydown', onKeydown);
      };

      if (cartCount(mount) <= 0) {
        resetCartCycle(mount);
        return;
      }

      if (isCartOrCheckoutPage(mount)) {
        clearScheduledWork(mount);
        hideReminder(mount);
        return;
      }

      if (isPaused(mount)) return;
      if (storageGet('sessionStorage', sessionKeys.dismissed) === '1') return;
      if (storageGet('sessionStorage', sessionKeys.shown) === '1') return;

      registerEligibleSession(mount, false, true);
      if (!isProductPage(mount)) scheduleReminder(mount);
    }

    function initAll(scope = document) {
      scope.querySelectorAll(mountSelector).forEach(initMount);
      if (scope.matches?.(mountSelector)) initMount(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    if (document.readyState === 'complete') {
      markPageLoaded();
    } else {
      window.addEventListener('load', markPageLoaded, { once: true });
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const mount = event.target.querySelector(mountSelector);
      mount?._cartReminderCleanup?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
